export default __webpack_public_path__ + "Content/Images/content/make-savings-a-priority.jpg";